import "../js/mobileNavigation.plugin.js";
import "../js/dropdown.plugin.js";
import "../js/stickyHeader.plugin.js";

$(function() {
	$('header.primary').stickyHeader();
    $('nav.primary').dropdown();
});